import { Deferred, getWebInitTimestamp, isIOS } from './util';
const globalPropsMap = {
    containerInitCost: {
        query: (globalProps) => {
            var _a;
            const val = (_a = globalProps.templateResData) === null || _a === void 0 ? void 0 : _a.container_init_cost;
            return {
                isResolved: val === 0 || Boolean(val),
                val,
            };
        },
        value: new Deferred(),
    },
    containerInitTotalTime: {
        query: (globalProps) => {
            let val = 0;
            const timestamp = globalProps.containerInitTime;
            if (timestamp) {
                val = getWebInitTimestamp() - parseInt(timestamp);
            }
            return {
                isResolved: timestamp !== null && timestamp !== undefined,
                val,
            };
        },
        value: new Deferred(),
    },
    htmlFromGecko: {
        query: (globalProps) => {
            var _a;
            const resFrom = (_a = globalProps.templateResData) === null || _a === void 0 ? void 0 : _a.res_from;
            const fromGecko = resFrom === 'gecko' ? 'true' : 'false';
            return {
                isResolved: Boolean(resFrom),
                val: { resFrom, fromGecko },
            };
        },
        fallback: () => {
            var _a;
            let resFrom = 'serverTiming_unknown';
            let fromGecko = 'unknown';
            if (!isIOS()) {
                const perfEntry = (_a = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('navigation')) === null || _a === void 0 ? void 0 : _a[0];
                if (perfEntry === null || perfEntry === void 0 ? void 0 : perfEntry.serverTiming) {
                    resFrom = perfEntry.serverTiming.length === 0 ? 'serverTiming_true' : 'serverTiming_false';
                    fromGecko = perfEntry.serverTiming.length === 0 ? 'true' : 'false';
                }
            }
            return {
                isResolved: true,
                val: { resFrom, fromGecko },
            };
        },
        value: new Deferred(),
    },
    geckoChannelName: {
        query: (globalProps) => {
            var _a;
            const val = (_a = globalProps.templateResData) === null || _a === void 0 ? void 0 : _a.gecko_channel;
            return {
                isResolved: val !== null && val !== undefined,
                val,
            };
        },
        value: new Deferred(),
    },
    deviceScore: {
        query: (globalProps) => {
            var _a;
            if (isIOS()) {
                return {
                    isResolved: true,
                    val: undefined,
                };
            }
            const score = (_a = globalProps.deviceScore) === null || _a === void 0 ? void 0 : _a.overall_score;
            return {
                isResolved: score !== null && score !== undefined,
                val: {
                    score: score !== null && score !== void 0 ? score : 0,
                    scoreRounded: score ? Math.floor(score) : 0,
                },
            };
        },
        value: new Deferred(),
    },
    networkLevel: {
        query: (globalProps) => {
            const level = globalProps.networkLevel;
            return {
                isResolved: level !== null && level !== undefined,
                val: level !== null && level !== void 0 ? level : undefined,
            };
        },
        value: new Deferred(),
    },
    appVersion: {
        query: (globalProps) => {
            const val = globalProps.appVersion;
            return {
                isResolved: val !== null && val !== undefined,
                val,
            };
        },
        value: new Deferred(),
    },
};
export { globalPropsMap };
//# sourceMappingURL=inappGlobalPropsMetric.js.map